/// <reference path="inhomewho.js" />
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import moment from 'moment-timezone';
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
import { logUI } from "../../api/andyliticsApi";
import { Redirect } from "react-router-dom";
import Spinner from '../common/spinner';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Notifier, DatePicker, ButtonGroupItem, Card, Divider, Typography, ContentSwitcher } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomeSplitLayout } from "./layout"

const InHomeWhen = ({ history, eligibilityResponses, dateTimeError, getAvailableTimes, setApptTime, availableApptsPending, availableDateTimes, enabledDays, selectedDateTime, refreshInterval, screenBreakPoint }) => {

    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [showWarning, setShowWarning] = useState(false);
    const [displayMonth, setDisplayMonth] = useState(null)
    const [displayTime, setDisplayTime] = useState(null)
    const [timeOfDay, setTimeOfDay] = useState('AM');

    const timeZone = Tools.getCentralDateWithFormat(new Date(), "z")

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhen.Displayed`, new Date(), Tools.getURLPath());
        getAvailableTimes();
        if (selectedDateTime && typeof(selectedDateTime) !== undefined) {
            const selectedTime = new Date(selectedDateTime);
            let formatTime = Tools.timeformat(selectedTime);
            history.location.state?.isPreviousClicked && setDisplayTime(formatTime);
            setSelectedDay(Tools.dateSimpleFormat(selectedDateTime));
            setSelectedTime(selectedTime);
            setTimeOfDay(formatTime?.includes('AM') ? 'AM' : 'PM');
        }
    }, []);

    useEffect(() => { // Refresh data every two minutes
        const interval = setInterval(() => {
            logUI(`MBHWeb.UI.InHomeSchedulingWhen.TimesRefreshed`, new Date(), Tools.getURLPath());
            getAvailableTimes(true);
        }, refreshInterval);

        return () => clearInterval(interval);
    }, [refreshInterval])

    useEffect(() => {
        if (selectedDay && availableDateTimes) {
            let foundMatchingDay = availableDateTimes.find(d => {
                return d.slots.length && d.date === Tools.dateSimpleFormat(selectedDay);
            })
            if (!foundMatchingDay) {
                setSelectedDay(enabledDays[0])
                setSelectedTime(null);
                setApptTime(null)
            } else if (selectedTime && availableDateTimes) {
                let foundMatchingDateTime = availableDateTimes.find(dt => {
                    return dt.slots.find(slot => {
                        return slot === selectedTime;
                    })
                })
                if (!foundMatchingDateTime) {
                    setSelectedTime(null);
                    setApptTime(null)
                }
            }
        }
    }, [availableDateTimes])

    useEffect(() => {
        if (!selectedDay) {
            if (selectedDateTime && availableDateTimes && enabledDays) {
                let foundMatchingDateTime = availableDateTimes.find(dt => {
                    return dt.slots.find(slot => {
                        return slot === selectedDateTime;
                    })
                })
                if (!foundMatchingDateTime) {
                    setSelectedDay(enabledDays[0])
                    setSelectedTime(null);
                    setApptTime(null)
                }
                else {
                    let day = Tools.toJSDate(selectedDateTime)
                    day.setHours(0)
                    setSelectedDay(day);
                    setSelectedTime(selectedDateTime)
                }
            }
            else if (enabledDays) {
                setSelectedDay(enabledDays[0])
            }
        }
    }, [selectedDay, enabledDays, selectedDateTime, availableDateTimes])


    const handleTimeChange = React.useCallback((slot) => {
        let date = Tools.toJSDate(slot);
        let formattedTime = moment(date).tz("America/Chicago").format("h:mm A")
        setDisplayTime(formattedTime)
        setSelectedTime(slot)
    }, [])

    // eslint-disable-next-line react/display-name
    const TimeSlotItem = ({ slot, formattedTime, selectedTime }) => {
        return <ButtonGroupItem
                label={formattedTime}
                selected={selectedTime === slot}
                value={slot}
                onClick={(e, value) => handleTimeChange(value)}
            />;
    }

    const getSlots = (day) => availableDateTimes?.find(d =>
        d.date === Tools.getDateStrByFormat(day, "YYYY-MM-DD")
    )?.slots ?? []

    useEffect(() => {
        if (!selectedDay) return;
        const selectedDayString = Tools.dateSimpleFormat(new Date(selectedDay));
        //let date = new Date(selectedDay).toLocaleString('en-US', { year: "numeric", month: "long", day: "numeric" })
        let date = new Date(selectedDay).toLocaleString('en-US', { weekday: "long", month: "short", day: "numeric" });
        setDisplayMonth(date)

        if (selectedTime) {
            let timeObject = new Date(selectedTime)
            let timeString = Tools.dateSimpleFormat(timeObject);

            if (selectedDayString !== timeString) {
                setSelectedTime(null)
                setApptTime(null);
            }
        }

    }, [selectedDay])

    const timeButtons = React.useMemo(() => {
       
        if (!selectedDay) return <></>
        let timeSlots = [];

        getSlots(selectedDay)
            .map((slot, i) => {
                let date = Tools.toJSDate(slot);
                let formattedTime = moment(date).tz("America/Chicago").format("h:mm");
                if (moment(date).tz("America/Chicago").format("A").toLowerCase() === timeOfDay.toLowerCase()) {
                    timeSlots.push(<TimeSlotItem key={i} slot={slot} formattedTime={formattedTime} selectedTime={selectedTime} />);
                }
            })
        return (timeSlots.length > 0
            ? <div className="in-home__time-slots-times-btns">{timeSlots}</div>
            : <Typography type="body-01" tag="div" textAlign="center">No {timeOfDay} times available</Typography>);
    }, [selectedDay, availableDateTimes, handleTimeChange, selectedTime, timeOfDay])

    const handleOnDayClick = React.useCallback((value, selected, disabled) => {       
        if (!disabled) {
            setDisplayTime(null)
            value.setHours(0);
            setSelectedDay(value);
        }
    }, [])

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhen.Previous.Clicked`, new Date(), Tools.getURLPath());
        history.push("/inhomeschedule/s5")
    }

    const onClickNext = () => {
        if (selectedDay && selectedTime) {
            setApptTime(selectedTime);
            logUI(`MBHWeb.UI.InHomeSchedulingWhen.Next.Clicked`, new Date(), Tools.getURLPath());
            history.push('/inhomeschedule/s7');
        } else {
            setShowWarning(true)
        }
    }

    const isNextButtonDisabled = () => {
        return (!selectedDay || !selectedTime);
    }
    const toggleTimeOfDay = (timeOfDay) => {
        setTimeOfDay(timeOfDay);
    }

    return (
        <>
            {!eligibilityResponses ? <Redirect to='/inhomeschedule/s5' /> :
                <>
                    <InHomeSplitLayout
                        className="inhome-scheduling-when-container"
                        progressPercent={6 / 7 * 100}
                    >
                        <InHomeMainPanel
                            heading="When would you like to schedule your appointment?"
                            subheading="All times are in CDT"
                            schedulingButtons={{
                                disabledNext: isNextButtonDisabled(),
                                leftOnClick: onClickPrevious,
                                rightOnClick: onClickNext
                            }}
                            centerSchedulingQuestions={true}
                        >
                            <div className="row">
                                <div className="col-12 when-detail-wrapper">
                                    {availableApptsPending && <Spinner />}
                                    {dateTimeError &&
                                        <Notifier colorStyle="error">Failed to load. Please try again</Notifier>
                                    }
                                    <div className="in-home-date-time-container">
                                    {enabledDays && 
                                        <div className="in-home-date">
                                            <DatePicker
                                                enabledDays={enabledDays}
                                                minDate={new Date()}
                                                initialDate={selectedDay ? selectedDay : enabledDays[0]}
                                                selectedDays={selectedDay}
                                                onDayClick={handleOnDayClick}
                                                maxDate={enabledDays[enabledDays.length - 1]}
                                            />
                                        </div>
                                        }
                                        {selectedDay &&
                                            <div className="in-home-time">
                                                <Card>
                                                    <div className="in-home__time-slots-container">
                                                        <div className="in-home__time-slots-heading">
                                                            <Typography type="meta-02" bold tag="div" textAlign="center">
                                                                {displayMonth} available times
                                                            </Typography>
                                                            <Divider mTop="small" mBottom="none" mLeft="none" mRight="none" />
                                                        </div>
                                                        <div className="in-home__time-slots">
                                                            <div className="in-home__time-slots-toggle">
                                                                <ContentSwitcher
                                                                    options={['AM', 'PM']}
                                                                    defaultIndex={['AM', 'PM'].indexOf(timeOfDay)}
                                                                    onChange={(item) => toggleTimeOfDay(item)}
                                                                    size="sm"
                                                                />
                                                            </div>
                                                            <div className="in-home__time-slots-times">
                                                                {timeButtons}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Card>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </InHomeMainPanel>

                        <InHomeConfirmationModal />

                        <InHomeOverviewPanel datePhase={true} />
                    </InHomeSplitLayout>
                </>
            }
        </>
    );
}
const mapStateToProps = state => {
    let availableApptsResult = state.inHome.getAvailableApptsResult;
    let enabledDays = availableApptsResult?.data && availableApptsResult?.data.reduce((acc, day) => {
        //sometimes a day doesn't have any time slots left. if so, leave those out from the pickable days!
        if (day.slots?.length && day.slots?.length > 0) acc.push(Tools.toJSDate(day.date, "YYYY-MM-DD"));
        return acc
    }, [])
    return {
        eligibilityResponses: state.inHome.eligibilityResponses,
        selectedUsers: state.inHome.selectedUsers,
        availableApptsPending: state.inHome.getAvailableApptsPending,
        dateTimeError: !state.inHome.getAvailableApptsPending && availableApptsResult?.success === false,
        availableDateTimes: availableApptsResult?.data,
        enabledDays: enabledDays,
        selectedDateTime: state.inHome.selectedDateTime,
        refreshInterval: state.session.serverData?.inHomeApptRefreshInterval || 120000,
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAvailableTimes: (secret = false) => {
            dispatch({ type: types.GET_INHOME_APPTS, secret })
        },
        setApptTime: (selectedDateTime) => {
            dispatch({ type: types.SET_INHOME_DATETIME, selectedDateTime })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhen);